import React from 'react'
import SectionGroup from './sectionGroup'
import { Single } from './Section/Single'

const Nodes = props => props.children

const FilterMenuContainer = ({ theme, height }) => (
  <Nodes>
    <SectionGroup
      height={height}
      render={() => {
        return <Single theme={theme} />
      }}
    />
  </Nodes>
)

export default FilterMenuContainer



// WEBPACK FOOTER //
// ./src/components/FilterMenu/filterMenuContainer.js